// extracted by mini-css-extract-plugin
module.exports = {"divider":"style-module__divider___LlSiD","subtitle":"style-module__subtitle___kMo4B","description":"style-module__description___qkrtO"};